import { createSelector } from 'reselect';

// Config
import { getCreditCard3DSecureInfoSelector } from '@redux/reducers/payment/paymentSelector';

const threeDSecureState = createSelector([getCreditCard3DSecureInfoSelector], (creditCard3DSecureInfo) => ({
  action: creditCard3DSecureInfo?.creditCard3DSecureMerchantUrl || '',
  id: creditCard3DSecureInfo?.creditCard3DSecureFormId || '',
  inputData: creditCard3DSecureInfo?.creditCard3DSecureFormData || {},
}));

export default threeDSecureState;
